"use client";

import Link from "@/components/link";
import dynamic from "next/dynamic";

import {
  SiFacebook,
  SiFacebookHex,
  SiInstagram,
  SiTelegram,
  SiTelegramHex,
  SiYoutube,
} from "@icons-pack/react-simple-icons";

import useMoengageEventTracker from "@/hooks/use-moengage";

import EVENT_NAME from "@/hooks/use-moengage/event-name";
import EVENT_ATTRIBUTE from "@/hooks/use-moengage/event-attribute";

import { cn } from "@/lib/utils";

const LinkedinIcon = dynamic(() => import("../resources/icons/linked-in.svg"));

function FooterSocial({ className }) {
  const trackMoengageEvent = useMoengageEventTracker();

  const handleOnSocialShareClick = (platform) => () => {
    trackMoengageEvent(EVENT_NAME.FOLLOW_US_CLICKED, {
      [EVENT_ATTRIBUTE.SOCIAL_MEDIA_PLATFORM]: platform,
    });
  };

  return (
    <div
      className={cn(
        "container-studyiq relative mx-auto px-0 md:px-4 z-10",
        className
      )}
    >
      <div className="absolute top-1/2 left-0 right-0 -translate-y-1/2 -z-10 bg-gray-300 h-px" />

      <div className="flex items-center gap-x-5 px-6 py-3 bg-white rounded-full w-fit mx-auto">
        <span className="font-semibold whitespace-nowrap">Follow Us</span>

        <ul
          className={cn(
            "flex h-auto gap-x-3 [&>li]:flex-1 [&>li]:leading-0 [&>li>a]:inline-flex [&>li>a]:items-center [&>li>a]:leading-1",
            "[&>li>a]:justify-center [&>li>a]:size-6 md:[&>li>a]:size-8 [&>li>a]:transition-transform",
            "[&>li>a]:hover:scale-110 [&>li>a]:duration-300 [&>li>a]:ease-in-out"
          )}
        >
          <li>
            <Link
              href="https://www.facebook.com/studyiq/"
              className="rounded-full"
              title="Facebook"
              onClick={handleOnSocialShareClick("facebook")}
            >
              <SiFacebook className="size-6 md:size-8" color={SiFacebookHex} />
            </Link>
          </li>
          <li>
            <Link
              href="https://www.linkedin.com/company/studyiq"
              className="text-white bg-linkedin rounded-full"
              title="LinkedIn"
              onClick={handleOnSocialShareClick("linkedin")}
            >
              <LinkedinIcon
                className="size-3.5 md:size-5"
                viewBox="0 0 20 20"
              />
            </Link>
          </li>
          {/* <li>
            <Link
              href="https://twitter.com/studyiq"
              className="text-white bg-black rounded-full p-1.5"
              title="Twitter"
              onClick={handleOnSocialShareClick("twitter")}
            >
              <SiX className="size-3.5 md:size-5" />
            </Link>
          </li> */}
          <li>
            <Link
              href="https://t.me/Studyiqeducation"
              className="bg-white rounded-full"
              title="Telegram"
              onClick={handleOnSocialShareClick("telegram")}
            >
              <SiTelegram className="size-6 md:size-8" color={SiTelegramHex} />
            </Link>
          </li>
          <li>
            <Link
              href="https://www.youtube.com/channel/UCrC8mOqJQpoB7NuIMKIS6rQ"
              className="text-white rounded-full bg-red-500"
              title="Youtube"
              onClick={handleOnSocialShareClick("youtube")}
            >
              <SiYoutube className="size-4 md:size-5.5" />
            </Link>
          </li>
          <li>
            <Link
              href="https://www.instagram.com/studyiqias"
              className="text-white rounded-full gradient-instagram"
              title="Instagram"
              onClick={handleOnSocialShareClick("instagram")}
            >
              <SiInstagram className="size-4 md:size-5.5" />
            </Link>
          </li>
        </ul>
      </div>
    </div>
  );
}

export default FooterSocial;
